import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PricingCTA() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      className="mt-24 rounded-2xl bg-gradient-to-r from-indigo-500 to-purple-500 p-8 text-center text-white sm:p-12"
    >
      <h2 className="text-3xl font-bold">Ready to Transform Your Learning?</h2>
      <p className="mt-4 text-lg text-indigo-100">
        Join thousands of students already using StudySnap
      </p>
      <div className="mt-8">
        <Button
          size="lg"
          variant="secondary"
          className="bg-white text-indigo-600 hover:bg-indigo-50"
        >
          Start Your Free Trial
        </Button>
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 text-sm text-indigo-100">
        <Shield className="h-4 w-4" />
        14-day free trial • No credit card required
      </div>
    </motion.div>
  );
}